import * as React from 'react';
import './PortableHeader.css';
import { useDispatch } from 'react-redux';

import CutLogo from '../../../../assets/CutLogo.png';
import ZoomApp from '../../../../components/ZoomApp/ZoomApp';
import { resetDocumentZoom } from '../../../../components/ZoomApp/zoomDocument';
import useSearchPlayers from '../../../../hooks/useSearchPlayers';
import FullscreenIcon from '../../../../assets/Icons/FullscreenIcon.svg?react';
import { setPortableMode } from '../../../App/actions';
import Flex from '../../../../components/Flex/Flex';
import Randomizer from '../../../../components/Randomizer/Randomizer';
import AutopasteSwitch from '../../../../components/AutopasteSwitch/AutopasteSwitch';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import type { RefSelectProps } from 'antd/es/select';
import PlayerSearchOptionLink from '../../../../components/PlayerSearchOptionLink/PlayerSearchOptionLink';
import type { PlayerSearchOption } from '../../../../hooks/useSearchPlayers';

const PortableHeader = React.memo(() => {
  const { t } = useTranslation('translation');
  const dispatch = useDispatch();
  const playerSearchRef = React.useRef<RefSelectProps>(null);

  const {
    nicknameToFind,
    searchPlayer,
    focusPlayerSearch,
    blurPlayerSearch,
    selectPlayer,
    selectPlayerOption,
    options,
    clearAutocompletePlayers,
  } = useSearchPlayers();

  const handleClosePortableMode = React.useCallback(() => {
    resetDocumentZoom();
    dispatch(setPortableMode(false));
  }, [dispatch]);

  const handleSelectPlayerOption = React.useCallback(
    (option: PlayerSearchOption) => {
      selectPlayerOption(option.player);
      playerSearchRef.current?.blur();
    },
    [selectPlayerOption],
  );

  return (
    <header className="PortableHeader">
      <Flex className="PortableHeader__Content" gap={6} align="center">
        <div className="PortableHeader__Brand">
          <img className="PortableHeader__Logo" src={CutLogo} alt="Fish Hunter" />
          <ZoomApp />
        </div>

        <Select<number, PlayerSearchOption>
          className="PortableHeader__Select"
          ref={playerSearchRef}
          options={options}
          placeholder={t('search_for_players')}
          showSearch={{
            onSearch: searchPlayer,
            searchValue: nicknameToFind,
            filterOption: false,
          }}
          onChange={selectPlayer}
          value={null}
          onOpenChange={(open) => {
            if (!open) {
              clearAutocompletePlayers();
            }
          }}
          notFoundContent={nicknameToFind === '' ? null : undefined}
          onFocus={focusPlayerSearch}
          onBlur={blurPlayerSearch}
          optionRender={(option) => (
            <PlayerSearchOptionLink option={option.data} onSelect={handleSelectPlayerOption} />
          )}
        />

        <Flex className="PortableHeader__Actions" gap={5} align="center">
          <Randomizer />
          <AutopasteSwitch />
          <button
            type="button"
            className="PortableHeader__FullscreenIcon"
            onClick={handleClosePortableMode}
            aria-label={t('exit_portable_mode')}
            title={t('exit_portable_mode')}
          >
            <FullscreenIcon />
          </button>
        </Flex>
      </Flex>
    </header>
  );
});

export default PortableHeader;
